import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SessionService extends BaseService {
  constructor(protected http: HttpClient) {
    super('auth', http);
  }

  /**
   * Returns the current user's profile. The NestJS `/api/auth/session`
   * endpoint returns the user object directly; it's wrapped as `{ user }` to
   * preserve the shape the auth effects expect.
   */
  public getCurrentUserDetails(): Observable<any> {
    return this.http.get(`${environment.apiUrl}auth/session`).pipe(
      map((user) => ({ user })),
      share()
    );
  }
}
